module.exports = __webpack_public_path__ + "static/danah_fullbg-c954b2ea763e2fd00de27570544344c0.jpeg";